<div class="board-column">

	<div class="column-header">
		<div class="column-title">
			Client Nfs.
		</div>
	</div>

	<!-- <div class="tasks-container" cdkDropList [cdkDropListData]="column" (cdkDropListDropped)="onDropIn($event)"
		*libInView> -->


	<ng-container *ngIf="loadingg">
		<lib-progress-spinner></lib-progress-spinner>
	</ng-container>

	<div class="tasks-container" *ngIf="!loadingg">
		<div class="nfs-block" *ngFor="let clientNf of clientNfs">
			<app-client-message [clientNf]="clientNf" [ngClass]="{'resolved-nfs': clientNf.resolvedTime}"
				[isMobile]="isMobile" [fromProj]="false" (dismissMsg)="dismissMsg($event)"
				(deleteMsg)="deleteMsg($event)"></app-client-message>
		</div>
		<div class="no-nfs-block" *ngIf="clientNfs.length === 0">
			No notifications
		</div>
	</div>
</div>
